module.exports = __webpack_public_path__ + "media/img/frontend_application/notification/event_planner/invoice_sent-76354b21b7deaee6f1950ddd8f457660.png";